import "./Footer.css";

import React from "react";

function Footer() {
  return (
    <footer>
      <p>
        ©Copyright 2023 | Powered by
        <a href="https://alexlilov.vercel.app/" target="_blank">
          Aleksandar Lilov
        </a>
      </p>
    </footer>
  );
}

export default Footer;
